import { render, staticRenderFns } from "./Tab-Order.vue?vue&type=template&id=1b005a2c"
import script from "./Tab-Order.vue?vue&type=script&lang=js"
export * from "./Tab-Order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports